import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as types from '../../../constants/actionTypes';
import { MAX_LOCATION_COMMENTS_CHAR_LENGTH, MAX_SUPPORT_TICKET_CHAR_LENGTH, DATE_FORMAT } from '../../../constants/constants';
import { actions as supportTicketActions } from '../../../actions/supportActions';
import InputText from '../../Common/InputText';
import TextArea from '../../Common/TextArea';
import Button from '../../Common/Button';
import Notification from '../../Common/Notification';
import Moment from 'moment';
import LocationFiles from './LocationFiles';
import LocationContacts from './LocationContacts';
import AssignTasksDrawer from './AssignTasksDrawer';
import ReassignTasksDrawer from './ReassignTasksDrawer';
import LocationDetailsFinancials from './LocationDetailsFinancials';
import './LocationDetails.scss';
import Routes from '../../../constants/routes';

class LocationDetails extends React.Component {
	constructor(props, context) {
		super(props, context);

		const blankLocation = {
			id: 0,
			name: '',
			abbreviation: '',
			brandName: '',
			regionName: '',
			continentName: '',
			openingDate: '',
			managementCompanyName: '',
			areaName: '',
			typeName: '',
			comments: '',
			generalManagerEmail: '',
			generalManagerName: '',
			isSubscriptionFinancialsActive: false,
		};

		this.state = {
			location: blankLocation,
			blankLocation: blankLocation,
			assignmentCounts: {
				assignedCount: 0,
				unassignedCount: 0,
				needsReassignCount: 0,
			},
			changeRequest: {
				comments: '',
			},
			isChangeRequestVisible: false,
			selectedFile: null,
			showAssignTasksDrawer: false,
			showReassignTasksDrawer: false,
		};
	}

	componentDidMount = async () => {
		await this.loadFilters();
		await this.loadAssignmentCounts();
	};

	componentDidUpdate(prevProps) {
		// reload the details when the user changes locations
		// they could be searching for a location so make sure there is a value
		if (this.props.locationKey && this.props.locationKey !== prevProps.locationKey) {
			this.loadFilters();
			this.loadAssignmentCounts();
		}
	}

	loadFilters = async () => {
		try {
			const response = await this.props.locationDashboardActions.loadDetailsFilters(this.props.locationKey);
			if (response.type === types.LOAD_LOCATION_DASHBOARD_DETAILS_SUCCESS) {
				this.setState({
					location: {
						...this.state.blankLocation,
						...response.payload.location,
					},
				});
			} else if (response.type === types.LOAD_LOCATION_DASHBOARD_DETAILS_FAILURE) {
				Notification('error', 'Error', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	loadAssignmentCounts = async () => {
		try {
			const response = await this.props.locationDashboardActions.getTaskAssignmentCounts(this.props.locationKey);
			if (response.type === types.LOAD_TASK_ASSIGNMENT_COUNTS_SUCCESS) {
				this.setState({
					assignmentCounts: {
						...this.state.assignmentCounts,
						...response.payload,
					},
				});
			} else if (response.type === types.LOAD_TASK_ASSIGNMENT_COUNTS_FAILURE) {
				Notification('error', 'Error', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	onUpdateDetails = async () => {
		const newDetails = {
			locationKey: this.props.locationKey,
			comments: this.state.location.comments,
			generalManagerEmail: this.state.location.generalManagerEmail,
			generalManagerName: this.state.location.generalManagerName,
		};

		try {
			const response = await this.props.locationDashboardActions.updateDetails(newDetails);
			if (response.type === types.LOCATION_DASHBOARD_UPDATE_DETAILS_SUCCESS) {
				Notification('success', 'Location Details Updated', '');
			} else if (response.type === types.LOCATION_DASHBOARD_UPDATE_DETAILS_FAILURE) {
				Notification('error', 'Error', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	onCreateTicket = async () => {
		const ticket = {
			locationId: this.state.location.id,
			subject: 'Location Update Request',
			description: this.state.changeRequest.comments,
		};

		try {
			const response = await this.props.supportTicketActions.createSubscriptionTicket(ticket);
			if (response.type === types.CREATE_SUBSCRIPTION_TICKET_SUCCESS) {
				Notification('success', 'Support Ticket Created', '');
			} else if (response.type === types.CREATE_SUBSCRIPTION_TICKET_FAILURE) {
				Notification('error', 'Error', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	onRequestChange = () => {
		this.setState({ isChangeRequestVisible: true });
	};

	onRequestFormChange = (e) => {
		this.setState({ changeRequest: { ...this.state.changeRequest, [e.target.name]: e.target.value } });
	};

	onFormChange = (e) => {
		this.setState({ location: { ...this.state.location, [e.target.name]: e.target.value } });
	};

	onAssignTasks = () => {
		this.setState({ showAssignTasksDrawer: true });
	};

	onAssignTasksComplete = () => {
		this.setState({ showAssignTasksDrawer: false });
		this.loadAssignmentCounts();
	};

	onAssignTasksCancel = () => {
		this.setState({ showAssignTasksDrawer: false });
	};

	onReassignTasks = () => {
		this.setState({ showReassignTasksDrawer: true });
	};

	onReassignTasksComplete = () => {
		this.setState({ showReassignTasksDrawer: false });
	};

	onEditFinancialsClick = () => {
		this.props.history.push(Routes.DashboardLocationFinancials);
	};

	render() {
		return (
			<Fragment>
				<div className='row location-details-widget'>
					<div className='col-sm-12 col-md-6 details-section'>
						<div className='row g-0 align-items-center details-header'>
							<div className='col dashboard-widget-title'>Location Details</div>
							{this.state.location.isSubscriptionFinancialsActive && (
								<div className='col-auto'>
									<Button
										type='button'
										text='Edit Financials'
										bootstrapClass='btn btn-primary financials-btn'
										onClick={this.onEditFinancialsClick}
									/>
								</div>
							)}
						</div>

						{this.state.location.isSubscriptionFinancialsActive && (
							<LocationDetailsFinancials
								locationKey={this.props.locationKey}
								locationDashboardActions={this.props.locationDashboardActions}
							/>
						)}

						<div className='card mt-2'>
							<div className='card-body'>
								
								<div className='row g-3 mb-4'>
									<div className="col">
										<InputText
											name='generalManagerName'
											label='General Manager Name'
											type='text'
											value={this.state.location.generalManagerName}
											maxLength={100}
											onChange={this.onFormChange}
										/>
									</div>
									<div className="col">
										<InputText
											name='generalManagerEmail'
											label='General Manager Email'
											type='text'
											value={this.state.location.generalManagerEmail}
											maxLength={256}
											onChange={this.onFormChange}
										/>
									</div>
									<div className="col">
										<Button name='saveDetails' type='button' text='Save' bootstrapClass='secondary btn-save' onClick={this.onUpdateDetails} />
									</div>
									<div className="col">
										<div className='assignment-counts'>
											<div>{this.state.assignmentCounts.assignedCount} tasks assigned</div>
											<div>
												{this.state.assignmentCounts.unassignedCount} tasks unassigned{' '}
												{this.state.assignmentCounts.unassignedCount > 0 && (
													<span className='btn-link' onClick={this.onAssignTasks}>
														ASSIGN
													</span>
												)}
											</div>
											{this.state.assignmentCounts.needsReassignCount > 0 && (
												<div>
													{this.state.assignmentCounts.needsReassignCount} tasks need to be{' '}
													<span className='btn-link' onClick={this.onReassignTasks}>
														reassigned
													</span>
												</div>
											)}
										</div>
									</div>
									
								</div>

								<TextArea
									name='comments'
									label='General Location Details'
									rows={3}
									value={this.state.location.comments}
									maxLength={MAX_LOCATION_COMMENTS_CHAR_LENGTH}
									onChange={this.onFormChange}
								/>
								<div className='remaining-chars text-end'>
									{this.state.location.comments.length}/{MAX_LOCATION_COMMENTS_CHAR_LENGTH}
								</div>
							</div>
							<div className='card-footer'>
								<div className='row'>
									<div className='col-4'>
										<div className='mb-3'>
											<label className='form-control-label'>Name</label>
											<div className='label-value'>
												{this.state.location.name} ({this.state.location.abbreviation})
											</div>
										</div>
									</div>
									<div className='col-4'>
										<div className='mb-3'>
											<label className='form-control-label'>Opening Date</label>
											<div className='label-value'>{Moment.utc(this.state.location.openingDate).format(DATE_FORMAT)}</div>
										</div>
									</div>
									<div className='col-4'>
										<div className='mb-3'>
											<label className='form-control-label'>Brand</label>
											<div className='label-value'>{this.state.location.brandName}</div>
										</div>
									</div>
								</div>
								<div className='row'>
									<div className='col-4'>
										<div className='mb-3'>
											<label className='form-control-label'>Region</label>
											<div className='label-value'>{this.state.location.regionName}</div>
										</div>
									</div>
									<div className='col-4'>
										<div className='mb-3'>
											<label className='form-control-label'>Continent</label>
											<div className='label-value'>{this.state.location.continentName}</div>
										</div>
									</div>
									<div className='col-4'>
										<div className='mb-3'>
											<label className='form-control-label'>Unit</label>
											<div className='label-value'>{this.state.location.unit}</div>
										</div>
									</div>
								</div>
								<div className='row'>
									<div className='col-4'>
										<div className='mb-3'>
											<label className='form-control-label'>Management Company</label>
											<div className='label-value'>{this.state.location.managementCompanyName}</div>
										</div>
									</div>
									<div className='col-4'>
										<div className='mb-3'>
											<label className='form-control-label'>Area</label>
											<div className='label-value'>{this.state.location.areaName}</div>
										</div>
									</div>
									<div className='col-4'>
										<div className='mb-3'>
											<label className='form-control-label'>Property Type</label>
											<div className='label-value'>{this.state.location.typeName}</div>
										</div>
									</div>
								</div>
								<div className='row'>
									{this.state.isChangeRequestVisible ? (
										<div className='col-12'>
											<TextArea
												name='comments'
												label='Location Update Request'
												rows={3}
												value={this.state.changeRequest.comments}
												maxLength={MAX_SUPPORT_TICKET_CHAR_LENGTH}
												onChange={this.onRequestFormChange}
											/>
											<div className='remaining-chars text-end'>
												{this.state.changeRequest.comments.length}/{MAX_SUPPORT_TICKET_CHAR_LENGTH}
											</div>
											<div className='float-end'>
												<Button
													name='saveDetails'
													type='button'
													text='Submit Update Request'
													bootstrapClass='secondary'
													onClick={this.onCreateTicket}
												/>
											</div>
										</div>
									) : (
										<div className='col-12 change-request-link'>
											<div className='btn btn-link' onClick={this.onRequestChange}>
												Request Change
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
						<br />
						<br />
						<LocationContacts
							locationKey={this.props.locationKey}
							locationContactActions={this.props.locationContactActions}
							locationTaskActions={this.props.locationTaskActions}
							locationActions={this.props.locationActions}
						/>
						<br />
					</div>

					<div className='col-sm-12 col-md-6 files-section'>
						<LocationFiles
							locationKey={this.props.locationKey}
							locationDashboardActions={this.props.locationDashboardActions}
							locationTaskActions={this.props.locationTaskActions}
							filesActions={this.props.filesActions}
						/>
					</div>
				</div>
				{this.state.showAssignTasksDrawer && (
					<AssignTasksDrawer
						locationDashboardActions={this.props.locationDashboardActions}
						onComplete={this.onAssignTasksComplete}
						onCancel={this.onAssignTasksCancel}
						locationKey={this.props.locationKey}
					/>
				)}
				{this.state.showReassignTasksDrawer && (
					<ReassignTasksDrawer
						locationDashboardActions={this.props.locationDashboardActions}
						onComplete={this.onReassignTasksComplete}
						onCancel={this.onReassignTasksComplete}
						locationKey={this.props.locationKey}
					/>
				)}
			</Fragment>
		);
	}
}

LocationDetails.propTypes = {
	subscriptionId: PropTypes.string.isRequired,
	locationKey: PropTypes.string.isRequired,
	locationDashboardActions: PropTypes.object.isRequired,
	filesActions: PropTypes.object.isRequired,
	supportTicketActions: PropTypes.object.isRequired,
	locationTaskActions: PropTypes.object.isRequired,
	locationActions: PropTypes.object.isRequired,
	locationContactActions: PropTypes.object.isRequired,
	history: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
	return {
		supportTicketActions: bindActionCreators(supportTicketActions, dispatch),
	};
}

export default connect(null, mapDispatchToProps)(LocationDetails);
